import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpParams,
} from "@angular/common/http";
import { dataproc_v1 } from "googleapis";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  httpHeaders = new HttpHeaders({
    "Content-Type": "application/json",
  });
  httpHeadersFormData = new HttpHeaders({
    "Content-Type": "form-data",
  });

  saveUserUrl = "https://swpa211.app/Project211/211/v1/save_user";

  sendOtpUrl = "https://swpa211.app/Project211/211/v1/sendotp";

  sendEmailOtpUrl = "https://swpa211.app/Project211/211/v1/sendmailotp";

  verifyOtpUrl = "https://swpa211.app/Project211/211/v1/verifyotp.php";

  getAllServicesUrl = "https://swpa211.app/Project211/211/v1/getAllServices";

  searchServiceUrl = "https://swpa211.app/Project211/211/v1/search_services";

  saveSearchDataUrl = "https://swpa211.app/Project211/211/v1/save_search_data";

  userHistoryUrl = "https://swpa211.app/Project211/211/v1/getUserHistory";

  feedbackUrl = "http://52.183.131.20:8089/211/v1/updateFeedbackPermission";

  emailSearchDataUrl =
    "http://52.183.131.20/project211/send_search_data_mail.php";

  setPasswordUrl = "http://52.183.131.20:8089/211/v1/update_password";

  getAllUserUrl = "http://52.183.131.20:8089/211/v1/getAllUser";

  forgetPasswordUrl = "http://52.183.131.20:8089/211/v1/forget_password";

  AllVirtualSitesurl="https://swpa211.app/Project211/211/v1/getAllVirtualSites";

  constructor(private http: HttpClient) {}

  saveUser(data: any) {
    return this.http.post<any>(this.saveUserUrl, data, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }

  sendOtpEmail(data: any) {
    return this.http.post<any>(this.sendEmailOtpUrl, data, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }

  // sendOtpEmail(data:any){
  //   let formData: FormData = new FormData();
  //   formData.append('email', data);
  //   return this.http.post(this.sendEmailOtpUrl, formData)
  //       .map((response: Response) => {
  //           return response;
  //       });
  // }

  // sendOtpPhone(data:any){
  //   let formData: FormData = new FormData();
  //   formData.append('phone_no', data);
  //   return this.http.post(this.sendOtpUrl, formData)
  //       .map((response: Response) => {
  //           return response;
  //       });
  // }

  sendOtpPhone(data: any) {
    return this.http.post<any>(
      this.sendOtpUrl,
      {
        phone_no: data,
      },
      {
        headers: this.httpHeaders,
        observe: "response",
      }
    );
  }

  verifyOtpPhone(data: any) {
    return this.http.post<any>(this.verifyOtpUrl, data, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }

  verifyOtpEmail(data: any) {
    return this.http.post<any>(this.verifyOtpUrl, data, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }

  // verifyOtpPhone(data:any){
  //   console.log('verify otp phone',data);

  //   let formData: FormData = new FormData();
  //   formData.append('phone_no', data.phone_no);
  //   formData.append('otp',data.otp);
  //   return this.http.post(this.verifyOtpUrl, formData)
  //       .map((response: Response) => {
  //           return response;
  //       });
  // }

  // verifyOtpEmail(data:any){
  //   console.log('verify otp',data);
  //   let formData: FormData = new FormData();
  //   formData.append('email', data.email);
  //   formData.append('otp',data.otp);
  //   return this.http.post(this.verifyOtpEmailUrl, formData)
  //       .map((response: Response) => {
  //           return response;
  //       });
  // }

  setPassword(data: any) {
    return this.http.post<any>(this.setPasswordUrl, data, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }

  getAllUser() {
    return this.http.get<any>(this.getAllUserUrl, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }

  getAllServices(data: any) {
    return this.http.post<any>(this.getAllServicesUrl, data, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }

  searchFoodService(data: any) {
    return this.http.post<any>(this.searchServiceUrl, data, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }

  saveSearchData(data: any) {
    console.log("inside save search data", data);
    return this.http.post<any>(this.saveSearchDataUrl, data, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }

  forgetPassword(data: any) {
    return this.http.post<any>(this.forgetPasswordUrl, data, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }

  emailData(email, body, base64) {
    let formData: FormData = new FormData();
    formData.append("email", email);
    formData.append("body", body);
    formData.append("base64", base64);
    return this.http
      .post(this.emailSearchDataUrl, formData)
      .map((response: Response) => {
        return response;
      });
  }

  getUserHistory(data: any) {
    return this.http.post<any>(this.userHistoryUrl, data, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }

  updateFeedback(data: any) {
    return this.http.post<any>(this.feedbackUrl, data, {
      headers: this.httpHeaders,
      observe: "response",
    });
  }
getAllVirtualSites(data: any){
  return this.http.post<any>(this.AllVirtualSitesurl, data, {
    headers: this.httpHeaders,
    observe: "response",
  });
}

}


// const bodyAll = new HttpParams()
// .set('email',email)
// .set('body',body)
// .set('base64',base64);
// return this.http.post<any>(
//   this.emailSearchDataUrl,bodyAll,
//   {
//     headers: this.httpHeadersFormData
//       //  .set('Content-Type', 'multipart/form-data')
//   }
// );
